import {mock} from './index';

export default {
  getDomains: () => mock('/admin/domain/list'),
  createDomain: () => mock('/admin/domain/create'),
  modifyDomain: () => mock('/admin/domain/modify'),
  deleteDomain: () => mock('/admin/domain/delete'),
  getDomainRoleList: () => mock('/admin/domain/role/list'),
  getDomainUserGroupList: () => mock('/admin/domain/userGroup/list')
};
